import {memo} from 'react';

import styled from 'styled-components';

import {flipOnLTR, rotateOnRTL} from '../theme/flipOnLTR';
import {media} from '../theme/media';

import Button from './Button';

const StyledToggleSwitch = styled(Button).attrs(({isActive}: {isActive?: boolean}) => ({
  className: isActive ? 'selected-bg-on-contrast' : 'white-bg-on-contrast',
}))<{isActive: boolean}>`
  position: relative;
  flex-shrink: 0;
  width: 48px;
  ${media.minLargeMobile`
    width: 40px;  
  `}
  height: 24px;
  border-radius: 12px;
  background-color: ${({isActive, theme}) => (
    isActive
      ? theme.colors.contentBrand
      : theme.colors.gray300
  )};
  cursor: pointer;
  transition: background-color 0.3s ease;
  ${flipOnLTR`
    margin-right: 16px;
  `}
  ${rotateOnRTL}
`;

const ToggleKnob = styled.div<{isActive: boolean}>`
  position: absolute;
  top: 2px;
  left: ${({isActive}) => (isActive ? '26px' : '2px')};
  ${media.minLargeMobile`
    left: ${({isActive}) => (isActive ? '18px' : '2px')};
  `}
  width: 20px;
  height: 20px;
  background-color: ${({theme}) => theme.colors.surface};
  border-radius: 50%;
  transition: left 0.3s ease;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
`;

const ToggleSwitch = ({isActive, onClick, className, dataTestId}: {
  isActive: boolean;
  onClick: (newState: boolean) => void;
  className?: string;
  dataTestId?: string;
}) => {
  return (
    <StyledToggleSwitch
      isActive={isActive}
      onClick={() => onClick(!isActive)}
      className={className}
      data-test-id={dataTestId}
    >
      <ToggleKnob isActive={isActive}/>
    </StyledToggleSwitch>
  );
};

export default memo(ToggleSwitch);
